<template>
  <Popover :class="height">
    <Float auto-placement portal :offset="10">
      <PopoverButton class="outline-0">
        <BaseAvatar :icon="['fal', 'users']" hide-status :size="size" />
      </PopoverButton>
      <PopoverPanel
        v-slot="{ close }"
        class="z-10 w-screen max-w-sm px-4 sm:px-0 lg:w-72"
      >
        <div
          class="flex flex-col divide-y divide-slate-200 rounded-md border bg-white text-left shadow-2xl"
        >
          <div class="p-4">
            <BaseButton
              :title="$t('button.copy_to_all_event_from_defunt')"
              :icon="'copy'"
              class="w-full"
              size="small"
              @click="copyAllAssignedPersonsToDossier(close)"
            />
          </div>
          <div class="p-4">
            <div class="flex flex-col gap-2 pb-3">
              <SelectAssignmentStatus
                v-model="internalAssignementStatus"
                edition-mode
                required
                size="small"
              />
              <BaseButton
                v-show="needSave"
                class="w-full"
                :title="$t('button.save')"
                size="small"
                theme-color="bg-secondary text-contrast-secondary"
                @click="() => updateAssignedPeople(close)"
              />
            </div>
          </div>
          <div class="px-4 py-2">
            <BaseButton
              class="w-full"
              :title="$t('button.delete')"
              size="extra-small"
              color="danger"
              @click="() => removeAssignedPeopleFromEvent(close)"
            />
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import BaseAvatar from '@c/Avatar/BaseAvatar.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import SelectAssignmentStatus from '@c/InitialStateFormComponent/Enums/SelectAssignmentStatus.vue'

export default {
  name: 'AssignedUsersPopover',
  components: {
    SelectAssignmentStatus,
    BaseButton,
    BaseAvatar,
    Float,
    PopoverPanel,
    PopoverButton,
    Popover
  },
  props: {
    eventId: {
      type: String,
      required: true
    },
    assignedPeople: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    }
  },
  emits: ['event-updated', 'copy-assign', 'fetch-events'],
  data() {
    return {
      isComposeDialogOpen: false,
      composeType: null,
      internalAssignementStatus: null
    }
  },
  computed: {
    ...mapGetters({ getUser: 'metadata/getAllUserMetadata' }),
    height() {
      switch (this.size) {
        case 'extra-small':
          return 'h-6'
        case 'small':
          return 'h-8'
        case 'large':
          return 'h-10'
        case 'extra-large':
          return 'h-12'
        default:
          return 'h-9'
      }
    },
    needSave() {
      return this.internalAssignementStatus !== null
    }
  },
  methods: {
    ...mapActions({
      processUpdateAssignedPersonAction: 'planning/updateAssignedPerson',
      processUpdateAssignedPeopleAction: 'planning/updateAssignedPeople',
      processCopyAssignedPeopleDossierAction:
        'planning/copyAssignedPeopleDossier',
      processRemoveAssignedPersonAction: 'planning/removeAssignedPerson'
    }),
    updateAssignedPeople(close) {
      this.processUpdateAssignedPeopleAction({
        event_id: this.eventId,
        data: {
          assigned_users: this.assignedPeople,
          assignement_status: this.internalAssignementStatus
        }
      }).then((response) => {
        this.$h.toastSuccess(this.$t('toasts.updated'))
        this.$emit('event-updated', response.event)
        close()
      })
    },
    copyAllAssignedPersonsToDossier(close) {
      this.processCopyAssignedPeopleDossierAction({
        event_id: this.eventId
      }).then((response) => {
        this.$h.toastSuccess(this.$t('toasts.updated'))
        this.$emit('fetch-events')
        close()
      })
    },
    removeAssignedPeopleFromEvent(close) {
      this.processRemoveAssignedPersonAction({
        event_id: this.eventId,
        data: {
          assigned_users: this.assignedPeople
        }
      }).then((response) => {
        this.$h.toastSuccess(this.$t('toasts.updated'))
        this.$emit('event-updated', response.event)
        close()
      })
    }
  }
}
</script>
